import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async store(): Promise<any> {
    return await this.call('/spa/companies', {
      method: 'post',
    })
  }

  async show(): Promise<any> {
    return useAsyncData('company', () => this.call('/spa/company'), {
      lazy: false,
      deep: false,
    })
  }

  async update(data: any): Promise<any> {
    return await this.call('/spa/company', {
      method: 'put',
      body: {
        ...data,
        influencer_target_category:
          data.influencer_target_category?.id === -1 ? null : data.influencer_target_category?.id,
      },
    })
  }

  async updateLogo(file: Blob): Promise<any> {
    const formData: FormData = new FormData()
    formData.append('logo', file)

    return await this.call('/spa/company/logo', {
      method: 'put',
      body: formData,
    })
  }

  async swap(id: number): Promise<any> {
    return await this.call(`/spa/companies/${id}/swap`, {
      method: 'post',
    })
  }
}
